import { IUseContentPagePreviewProps } from 'components/Pages/Admin/shared/ItinerariesItemLanding/types';

import { getHandledPageName } from '../../../utils';
import * as types from './../../types';

type Props = types.CommonFormValues | (IUseContentPagePreviewProps & types.CommonFormValues);

export const handleFormValues = (formValues: Props) => {
  const handle = getHandledPageName(formValues);

  return {
    ...formValues,
    handle,
  };
};
